class OpenSwatchModal extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      const button = this.querySelector("button");
      (button || this).dispatchEvent(
        new CustomEvent("swatch-modal:open", { bubbles: true }),
      );
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("open-swatch-modal")) {
  customElements.define("open-swatch-modal", OpenSwatchModal);
}
